import { Box } from "@mui/system";
import CabinList from "pages/vending/cabin/list/CabinList";
import TrayList from "pages/vending/tray/list/TrayList";
import React from "react";
import { useParams } from "react-router-dom";

const RefillProducts = () => {
  const { m_id } = useParams();
  const [currentCabin, setCurrentCabin] = React.useState(null);
  const [selectedItem, setSelectedItem] = React.useState(null);
  return (
    <Box padding={2}>
      <CabinList
        currentItem={currentCabin}
        setCurrentItem={setCurrentCabin}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        m_id={m_id}
        editable={false}
      />
      {selectedItem && <TrayList cabin={selectedItem} refill_mod={true} />}
    </Box>
  );
};

export default RefillProducts;
